/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerBeneficiariesDtoApiResponse } from '../../models/customer-beneficiaries-dto-api-response';
import { EditCustomerBeneficiariesCommand } from '../../models/edit-customer-beneficiaries-command';

export interface EditCustomerBeneficiaryAsync$Plain$Params {
  id: number;
  beneficiaryId: number;
      body?: EditCustomerBeneficiariesCommand
}

export function editCustomerBeneficiaryAsync$Plain(http: HttpClient, rootUrl: string, params: EditCustomerBeneficiaryAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerBeneficiariesDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, editCustomerBeneficiaryAsync$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('beneficiaryId', params.beneficiaryId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerBeneficiariesDtoApiResponse>;
    })
  );
}

editCustomerBeneficiaryAsync$Plain.PATH = '/api/customer/{id}/beneficiary/{beneficiaryId}';
